import { Trans, useLingui } from '@lingui/react/macro';

import InlineText from '@/design_system/Typography/InlineText';
import IconUserRefusal from '@/icons/UserRefusal.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import type { TNotificationOfType } from '@/models/notification';

export const InitialQuoteRefusedNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'initial_quote_refused'>;
}) => {
  const { t } = useLingui();

  return (
    <BaseNotification
      icon={<IconUserRefusal />}
      type="danger"
      notification={notification}
      notificationLabel={t({
        id: 'notification.initial-quote-refused.label',
        message: `Quote refused for request ${notification.request.reference}`,
      })}
      notificationHeader={(color) => (
        <Trans id="notification.initial-quote-refused">
          <InlineText weight="medium" color={color}>
            The client
          </InlineText>{' '}
          refused the quote
        </Trans>
      )}
    />
  );
};
